<div class="fx-affiliate-manage-setting">
  <div class="row">
    <div class="col">
      <fx-page-header title="{{''}}"></fx-page-header>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <fx-ib-level
        [permission]="permission"
        [config]="listConfig"
      ></fx-ib-level>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col">
      <fx-direct-user
        [permission]="permission"
        [config]="listConfig"
      ></fx-direct-user>
    </div>
  </div> -->
</div>
